import React from 'react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div role="alert" style={{
      position: 'fixed', top: 0, left: 0, right: 0,
      backgroundColor: '#f59e0b', color: '#000',
      padding: '8px 16px', textAlign: 'center',
      zIndex: 9999, fontSize: '14px', fontWeight: 500
    }}>
      You are offline. Some features may be unavailable.
    </div>
  );
}
